export class ModalRemocaoObservacaoController {
  constructor($scope, $uibModalInstance, Pedido, pedidoId) {
    $scope.pedidoId = pedidoId;

    $scope.confirmar = async () => {
      try {
        await Pedido.removerObservacao($scope.pedidoId);
        $uibModalInstance.close({});
      } catch (err) {
        $uibModalInstance.dismiss(err);
      }
    };

    $scope.cancelar = function() {
      $uibModalInstance.dismiss('cancel');
    };
  }
}
